import React, {useEffect, useState} from 'react';
import {
    Grid, Stack
} from "@mui/material";
import {useIntl} from "react-intl";
import {MailTemplateSearchCondition} from "../../../../../modules/mail/dto/MailTemplateSearchCondition";
import FormFieldText from "../../../../../components/FormFieldText";
import SearchButton from "../../../../../components/buttons/SearchButton";
import AddButton from "../../../../../components/buttons/AddButton";

export type SearchConditionProps = {
    searchCondition: MailTemplateSearchCondition;
    onChange: (name: string, value: any) => void;
    onClickSearch: () => void;
    onClickAdd: () => void;
};

const SearchCondition: React.FC<SearchConditionProps> = (props) => {
    const intl = useIntl();

    return (
        <Grid container columnSpacing={2} alignItems="center">
            <Grid item xs={4}>
                <FormFieldText label={intl.formatMessage({id: "MAIL_TEMPLATE_CODE"})}
                               value={props.searchCondition.code}
                               onChange={(value) => {
                                   props.onChange("code", value)
                               }}/>
            </Grid>
            <Grid item xs={4}>
                <FormFieldText label={intl.formatMessage({id: "MAIL_TEMPLATE_NAME"})}
                               value={props.searchCondition.name}
                               onChange={(value) => {
                                   props.onChange("name", value)
                               }}/>
            </Grid>
            <Grid item xs={4}>
                <Stack direction={'row'} spacing={2}>
                    <SearchButton onClick={props.onClickSearch}/>
                    <AddButton onClick={props.onClickAdd}/>
                </Stack>
            </Grid>
        </Grid>
    );
};

export default SearchCondition;
